import { createAsyncThunk } from "@reduxjs/toolkit";
import { AUTHENTICATION } from "../../utils/constants/APIURL.constants";

import AppService from "../../services/AppService";

export const login = createAsyncThunk(
  "admin/login",
  async (obj, { rejectWithValue }) => {
    try {
      return await AppService.postCall(obj, AUTHENTICATION.LOGIN);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const resendOTP = createAsyncThunk(
  "admin/resendOtp",
  async (obj, { rejectWithValue }) => {
    try {
      return await AppService.postCall(obj, AUTHENTICATION.RESEND_EMAIL_OTP);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const verifyEmail = createAsyncThunk(
  "admin/verifyEmail",
  async (obj, { rejectWithValue }) => {
    try {
      return await AppService.postCall(obj, AUTHENTICATION.EMAIL_VERIFICATION);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
